export const CampaignManualStatus = {
    Pending: 0,
    Active: 1,
    Canceled: 2,
}